var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.5303300619125366,0.5303300619125366,-0.5303300619125366,0.5303300619125366,251.87744140625,229.46226501464844)",
    opacity: 0.0001738775495604017
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,21.643999099731445,-261.9330139160156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,297.4289855957031,1.4450000524520874)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,2.5869998931884766,303.4219970703125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-271.09100341796875,20.99799919128418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.01308930478990078,0.7498857975006104,-0.7498857975006104,0.01308930478990078,262.7327880859375,234.9120635986328)",
    opacity: 0.00008607914474666245
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,21.643999099731445,-261.9330139160156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,297.4289855957031,1.4450000524520874)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,2.5869998931884766,303.4219970703125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-271.09100341796875,20.99799919128418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-19.16699981689453 C10.578267097473145,-19.16699981689453 19.16699981689453,-10.578267097473145 19.16699981689453,0 C19.16699981689453,10.578267097473145 10.578267097473145,19.16699981689453 0,19.16699981689453 C-10.578267097473145,19.16699981689453 -19.16699981689453,10.578267097473145 -19.16699981689453,0 C-19.16699981689453,-10.578267097473145 -10.578267097473145,-19.16699981689453 0,-19.16699981689453z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8999999761581421,0,0,0.8999999761581421,241.94000244140625,254.3179931640625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.260000228881836,-8.317999839782715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lottie-colored-parts",
    fill: "rgb(23,179,27)",
    fillOpacity: 1,
    d: " M0,-149.23199462890625 C82.36113739013672,-149.23199462890625 149.23199462890625,-82.36113739013672 149.23199462890625,0 C149.23199462890625,82.36113739013672 82.36113739013672,149.23199462890625 0,149.23199462890625 C-82.36113739013672,149.23199462890625 -149.23199462890625,82.36113739013672 -149.23199462890625,0 C-149.23199462890625,-82.36113739013672 -82.36113739013672,-149.23199462890625 0,-149.23199462890625z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8999999761581421,0,0,0.8999999761581421,249.37400817871094,246.831787109375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.8399999737739563,0,0,0.8399999737739563,-5,-7)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 25,
    d: " M-83.92900085449219,12 C-83.92900085449219,12 -22.422000885009766,78 -22.422000885009766,78 C-22.422000885009766,78 100.21399688720703,-53.237998962402344 100.21399688720703,-53.237998962402344"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.ec8e4a1c798aea3ebbc617df391248f8.svg";
export { ForwardRef as ReactComponent };